import React from 'react';
import { TopIssueUtils } from 'components/exception/ProductSummaryPage/TopIssueList/TopIssueList';
import { formatCrashPercentageString } from 'utils/format/format-number';
import { Tooltip } from 'antd';
import { ze } from 'utils/zhEn';
import i18n from 'i18n';
import { ix } from 'utils/i18n-with-context';

export function renderBarChart(originData, isRate, formatter, sortKey, key, key2Color, onClickBar,
  { needProportion = false } = {},
) {
  const sortOption = sortKey.includes('Connect') ? 'access' : sortKey.includes('Rate') ? 'rate' : 'affect';
  let rollUpValueLabelText = undefined;
  if (needProportion) {
    if (sortOption === 'affect') {
      rollUpValueLabelText = ix(i18n.t('RANKINGLIST.userNumAffectProportion'));
    } else if (sortOption === 'access') {
      rollUpValueLabelText = ix(i18n.t('RANKINGLIST.userNumConnectProportion'));
    }
  }

  function getPercent(crashUser, accessUser) {
    let result = 0;
    if (accessUser > 0 && crashUser >= 0) {
      let temp = isRate ? (100 * crashUser / accessUser) : (crashUser / accessUser);
      result = temp.toFixed(2);
    }
    return result;
  }

  function renderList(list){
    if(list.length >= 5){
      return list;
    } else {
      const remaining = 5 - list.length;
      const newList = list.concat(Array(remaining).fill({}));
      return newList;
    }
  }

  function calculatedWidth(maxValue,value){
    const result = Math.max(value/maxValue, 0.01) * 100;
    return (result + '%');
  }

  const data = renderList(originData).map(item => {
    let value;
    if (sortOption === 'affect') {
      value = item.crashUser;
    } else if (sortOption === 'access') {
      value = item.accessUser;
    } else {
      value = getPercent(item.crashUser, item.accessUser);
    }
    let proportionPercentage;
    if (needProportion) {
      let rollUpValue;
      if (sortOption === 'affect') {
        rollUpValue = item.fieldRollupExceptionDevices;
      } else if (sortOption === 'access') {
        rollUpValue = item.fieldRollupAccessDevices;
      }
      if (rollUpValue > 0) {
        proportionPercentage = value / rollUpValue * 100;
      }
    }
    return {
      value,
      name: item.fieldValue,
      fieldOriginalValue: item.fieldOriginalValue,
      fieldRollupAccessDevices: item.fieldRollupAccessDevices,
      accessDevices: item.accessDevices,
      proportionPercentage,
    };
  });

  data.sort((a, b) => b.value - a.value);
  const valueList = data.map(item => item.value || 0);
  // 率的最大值限制最小为3
  const maxValue = sortOption === 'rate' ? Math.max(3, Math.max(...valueList)) : Math.max(...valueList);

  return <div style={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between'}}>
    <ul style={{flexGrow: '1'}}>
      {data.map((item, index) => (<li style={{ height: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', paddingBottom: '1px' }}>
        {(item.name && item.value > 0) && <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            if (typeof onClickBar === 'function') {
              onClickBar(key, item.fieldOriginalValue);
            }
          }}
        >
          <div style={{fontSize: '12px', lineHeight: '12px', marginBottom: '6px'}}>{item.name}</div>
          <div style={{display:'flex', alignItems:'center', height:'10px'}}>
            <div style={{position:'relative', width:'100%',height:'100%',background:'#ededed',borderRadius:'4px',}}>
              <div style={{position:'absolute',width:calculatedWidth(maxValue,item.value), top: '0px', left: '0px',
               height:'100%', borderRadius:'4px', background: 'linear-gradient(90deg, #7C73F3, #A194FF)', overflow: 'hidden'}}></div>
            </div>
          </div>
        </div>}
      </li>) )}
    </ul>
    <ul style={{marginLeft: '6px'}}>
      {data.map((item, index) => (<li style={{ height: '48px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', fontSize: '12px', lineHeight: '12px', flexShrink: 0 }}>
      {(item.name && item.value > 0) && <div
        style={{ cursor: 'pointer', display: 'flex', whiteSpace: 'nowrap' }}
        onClick={() => {
          if (typeof onClickBar === 'function') {
            onClickBar(key, item.fieldOriginalValue);
          }
        }}
      >
        <div>{ isRate ? `${item.value}%` : item.value}</div>
        { item.proportionPercentage && <Tooltip
          title={ rollUpValueLabelText }
        >
          <div
            style={{ marginLeft: '4px', color: '#AAA' }}
          >({TopIssueUtils.formatPercentage(item.proportionPercentage)})</div>
          </Tooltip>
        }
      </div>}
    </li>) )}
    </ul>
  </div>
}
